/**
 * Explicatia bifei "Allow Wi-Fi diagnostics" (Connection Quality faza 3),
 * aceeasi pe cardul aparatului si pe panoul firmei.
 */
export const LOCATION_DOC = 'https://learn.microsoft.com/en-us/windows/win32/nativewifi/wi-fi-access-location-changes'

export function WifiDiagHelp({ doc }: { doc?: string }) {
  return (
    <>
      On Windows 11, location must be allowed for desktop apps before the agent can see which access point (BSSID) the
      machine is connected to. With this on, the agent allows it on the machine, like a company policy, and puts it back
      the way it was when you turn this off. It can also be set by GPO or Intune (
      <a href={doc ?? LOCATION_DOC} target="_blank" rel="noopener noreferrer">
        Microsoft: Wi-Fi access and location
      </a>
      ). Without it, the other Wi-Fi measurements still work - only the access point is missing.
    </>
  )
}
